// @flow
import React from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";

// simple line chart
const LineChart = ({ cat, data }) => {
  // default options
  const apexLineChartWithLables = {
    responsive: [
      {
        breakpoint: 480, // Establece el ancho máximo del contenedor
        options: {
          chart: {
            height: 100, // Ajusta la altura del gráfico para dispositivos más pequeños
          },
        },
      },
      // Puedes añadir más breakpoints con diferentes opciones si es necesario
    ],

    chart: {
      height: 200,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ["#727cf5", "#0acf97"],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      width: [3, 3],
      curve: "smooth",
    },
    colors: ["#0B9B2A", "#2782e4"],
    yaxis: {
      title: {
        text: "Mbps",
        style: {
          fontSize: "20px", // Tamaño de la fuente del título del eje Y
          color: "#000000",
        },
      },
    },
    grid: {
      row: {
        colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.2,
      },
      borderColor: "#0032E7",
    },
    markers: {
      style: "inverted",
      size: 6,
    },
    xaxis: {
      categories: cat,
      title: {
        text: "Tiempo real",
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "Mb";
        },
      },
    },
  };

  const apexLineChartWithLablesData = [
    {
      name: "Tráfico actual",
      // data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160],
      data,
    },
  ];

  return (
    <Card>
      <Card.Body>
        <h4 className="header-title mb-3">Tráfico Actual</h4>
        <div className="mt-3 chartjs-chart">
          <Chart
            options={apexLineChartWithLables}
            series={apexLineChartWithLablesData}
            type="line"
            className="apex-charts"
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default LineChart;
